import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CounterpartyAddressesColumn {
    ADDRESS = "address",
    LABEL = "label",
    PRIMARY = "primary",
    ACTIONS = "actions",
}

const AddressColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyAddressesColumn.ADDRESS),
});
const LabelColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyAddressesColumn.LABEL),
});
const PrimaryColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyAddressesColumn.PRIMARY),
});
const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(CounterpartyAddressesColumn.ACTIONS),
});

export const CounterpartyAddressesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.COUNTERPARTY_ADDRESSES),
    columns: z.array(
        z.discriminatedUnion("id", [
            AddressColumnSchema,
            LabelColumnSchema,
            PrimaryColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type CounterpartyAddressesView = z.infer<
    typeof CounterpartyAddressesViewSchema
>;
